import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { ApiError, api } from '../../lib/api'
import { useAuth } from '../../context/AuthContext'

function homeForRole(role: string) {
  if (role === 'super_admin' || role === 'atuune_admin') return '/admin'
  if (role === 'provider') return '/practice/provider'
  if (role === 'practice_owner' || role === 'practice_admin') return '/practice'
  if (role === 'patient') return '/patient'
  return '/'
}

export default function VerifyEmailPage() {
  const { token } = useParams<{ token: string }>()
  const { me, refreshMe } = useAuth()
  const [status, setStatus] = useState<'verifying' | 'verified' | 'error'>('verifying')
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    api(`/auth/verify-email/${token}`, { method: 'POST' })
      .then(() => {
        setStatus('verified')
        // Unconditional, not `if (me)`: on a fresh page load (the real path —
        // this route is reached from an emailed link, not in-app navigation)
        // AuthContext's own initial /me fetch hasn't resolved yet, so `me` is
        // still null here even for a logged-in patient. Without this refresh,
        // the cached `me` (and its "verify your email" banner) stays stale
        // until the next login/reload. Safe no-op if no token exists.
        refreshMe().catch(() => {})
      })
      .catch((err) => {
        setStatus('error')
        setError(err instanceof ApiError ? err.message : 'This verification link is invalid or has expired.')
      })
  }, [token])

  return (
    <div className="auth-shell warm-theme">
      <div className="auth-card">
        {status === 'verifying' && <h1>Verifying your email…</h1>}
        {status === 'verified' && (
          <div>
            <h1>Email verified</h1>
            <p className="muted">Thanks — your email address is confirmed.</p>
            <Link className="btn full" style={{ marginTop: 10, display: 'block', textAlign: 'center' }} to={me ? homeForRole(me.role) : '/login'}>
              {me ? 'Continue' : 'Sign in'}
            </Link>
          </div>
        )}
        {status === 'error' && (
          <div>
            <h1>Verification link invalid</h1>
            <p className="form-error" role="alert">{error}</p>
            <Link className="btn outline full" style={{ marginTop: 10, display: 'block', textAlign: 'center' }} to="/login">Back to sign in</Link>
          </div>
        )}
      </div>
    </div>
  )
}
